<section>
  <h6 class="typography-h6">{{ heading | translate }}</h6>
  <ng-content select="p[description]"></ng-content>
  <ng-content select="p[info-banner]"></ng-content>
  <ng-content select="[plan-comparison]"></ng-content>
  <ul class="details-list">
    <ng-content select="[billing-detail-item]"></ng-content>
  </ul>
  <ng-content select="p[savings-banner]"></ng-content>
  <ng-content select="p[neutral-banner]"></ng-content>
  <ng-content select="p[minus-banner]"></ng-content>
  <ng-content select="p[chart-banner]"></ng-content>
</section>
<ng-content select="div[footer-content]"></ng-content>
